
import lazySizes from "lazysizes";

import "./tabs";
import "./navDropdown";
import "./subnav";
import "./processSlide";
import "./pseudoElement"
import "./stickyNav";
import "./popupNav";
import "./accordion";
import "./calcHeightNav";
import "./rowWidth";
import "./modal";
import "./urgentMessage";
import "./areamap";
import "./connectionCalculator";
import "./tinySlider";

import priorityNav from "priority-nav";

// needed because prioritynav has a polyfill for this, but it's not working
Element.prototype.remove = function () {
    if (this.parentElement) {
        this.parentElement.removeChild(this);
    }
    else if (this.parentNode) {
        this.parentNode.removeChild(this);
    }
};

const mainNavToggle = document.querySelector(".main-nav__toggle")
mainNavToggle.addEventListener("click", () => {
    const html = document.querySelector(".html")
    if (html.classList.contains("html--lock")) {
        html.classList.remove("html--lock")
    } else {
        html.classList.add("html--lock")
    }
})

priorityNav.init({
    mainNavWrapper: "[data-priority-nav=\"wrapper\"]",
    mainNav: "[data-priority-nav=\"nav\"]",
    navDropdownLabel: "Mere",
    navDropdownBreakpointLabel: "&#9776;",
    navDropdownClassName: "main-nav__dropdown", // class used for the dropdown - this is a class name, not a selector.
    navDropdownToggleClassName: "main-nav__dropdown-toggle", // class used for the dropdown toggle - this is a class name, not a selector.
    breakPoint: 900,
    offsetPixels: 0, // increase to decrease the time it takes to move an item.
    throttleDelay: 200 // this will throttle the calculating logic on resize because i'm a responsible dev.
});
